import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RoleService } from '../services/role.service';

export const adminGuard: CanActivateFn = (route, state) => {
  let roleService = inject(RoleService);
  return roleService.isAdmin();
};
